import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AgreementDocument } from '../models/agreement-document';
import { InfoFieldModel } from '../models/info-field-model';
import { LanguageInfoModel } from '../models/language-info-model';
import { LanguagePageQuestions } from '../models/page-questions';
import { LoadingDataService } from '../repositories/loading-data.service';
import { BrowserStorageService } from '../services/browser-storage.service';
import { BaseDataService } from './base-data.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService extends BaseDataService {

  private _languagesInfoSubject = new ReplaySubject<Array<LanguageInfoModel>>();
  private _infoFieldsSubject = new ReplaySubject<Array<InfoFieldModel>>();
  private _pageQuestions = new ReplaySubject<Array<LanguagePageQuestions>>();
  private _agreements = new ReplaySubject<Array<AgreementDocument>>();
  private _direction = new ReplaySubject<string>();

  get direction() {
    return this._direction;
  }

  constructor(
    public http: HttpClient,
    public loadinService: LoadingDataService,
    private storageService: BrowserStorageService) {
    super(http, loadinService);
    this.refreshLanguagesInfo();

    this.refreshInfoFields(sessionStorage.getItem('lang'));
    this.refresQuestions(sessionStorage.getItem('lang'));
    this._direction.next('rtl');
  }

  public getLanguagesInfoSubject(): ReplaySubject<Array<LanguageInfoModel>> {
    return this._languagesInfoSubject;
  }

  public getInfoFieldSubject(): ReplaySubject<Array<InfoFieldModel>> {
    return this._infoFieldsSubject;
  }

  public getQuestions(): ReplaySubject<Array<LanguagePageQuestions>> {
    return this._pageQuestions;
  }

  public getAgreements(): ReplaySubject<Array<AgreementDocument>> {
    return this._agreements;
  }

  private refreshLanguagesInfo(): void {
    this.get<Array<LanguageInfoModel>>('data/getlanguageslist', langs => {
      this.setLanguagesInfo(langs);
    });
  }

  public refresQuestions(code: string, onFinish?: () => void): void {
    this.get<Array<LanguagePageQuestions>>('data/getquestions?code=' + code, questions => {
      this.setQuestions(questions);
      if (onFinish) {
        onFinish();
      }
    });
  }

  public refresAgreements(code: string, onFinish?: () => void): void {
    this.get<Array<AgreementDocument>>('data/getAgreements?code=' + code, agreements => {
      this.setAgreements(agreements);
      if (onFinish) {
        onFinish();
      }
    });
  }

  public refreshInfoFields(code: string, onFinish?: () => void): void {
    this.get<Array<InfoFieldModel>>('data/getinfofields?code=' + code, fields => {
      this.setInfoField(fields);
      if (onFinish) {
        onFinish();
      }
    });
  }

  private setLanguagesInfo(langs: Array<LanguageInfoModel>) {
    this._languagesInfoSubject.next(langs);
  }
  private setInfoField(fields: Array<InfoFieldModel>) {
    this._infoFieldsSubject.next(fields);
  }

  private setAgreements(agreements: Array<AgreementDocument>) {
    this._agreements.next(agreements);
  }

  private setQuestions(questions: Array<LanguagePageQuestions>) {
    this._pageQuestions.next(questions);
  }

  public setDirection(direction: string) {
    this._direction.next(direction);
  }

  public getTerms(onComplete: (langInfo: LanguageInfoModel) => void) {
    this.get<LanguageInfoModel>('data/getterms?code=' + this.storageService.getLocal('lang'), onComplete);
  }
}
